export enum AUCTION_ACTIVITY {
	ALL_ITEMS = 'All Items',
	ACTIVE = 'Active',
	CLOSED = 'Closed',
}

export enum AUCTION_BIDS_ACTIVITY {
	ALL_BIDS = 'All Items',
	WON = 'Won',
}

export enum AUCTION_TYPE {
	ALL_ITEMS = 'All Items',
	SILENT = 'Silent',
	LIVE = 'Live',
}

export enum AUCTION_VARIANT {
	SILENT_AUCTION = 'Silent auction',
	LIVE_AUCTION = 'Live auction',
}

export enum AUCTION_STATUS {
	ACTIVE = 1,
	CLOSED = 2,
}

export enum AUCTION_ONLINE_STATE {
	OFFLINE,
	ONLINE,
}
